import React from 'react';

const menuData = [
  {
    category: "Breakfast Favorites",
    items: [
      { name: "Northwest Salmon Hash", price: "$19.75", desc: "Northwest smoked salmon grilled with leeks and fresh-cut hash browns. Topped with two eggs, any style, then drizzled with creamy Lemon-Dill Sauce." },
      { name: "Corned Beef Hash", price: "$18.75", desc: "Hand-shredded corned beef brisket grilled with bell peppers, onions, and our fresh-cut hash browns. Topped with two eggs, then finished with a Horseradish-Shallot Crème." },
      { name: "Ultimate Polenta", price: "$18.75", desc: "Creamy chive polenta made with Cheddar and Parmesan cheese, topped with Hollandaise Sauce, crisp bacon, sautéed spinach and mushrooms, and two poached eggs." },
      { name: "Risotto Cakes & Eggs", price: "$18.25", desc: "Tender risotto cakes made with sautéed bacon, asparagus, mushrooms, red onions, and fresh basil, lightly breaded and grilled to perfection. Topped with two poached eggs." },
      { name: "Mushroom & Fromage Omelette", price: "$17.95", desc: "A three-egg omelette filled with our house-made Mushroom Pesto and Gruyère cheese. Finished with Herbed Goat Cheese." },
      { name: "Chef's Omelette", price: "$17.95", desc: "A hearty three-egg omelette filled with our house sausage, bacon, tomatoes, onions, and Cheddar cheese, then topped with avocado." },
      { name: "Day Breaker", price: "$16.25", desc: "Start your day off right with two eggs, prepared any style, and your choice of chicken sausage, pork & apple sausage, bacon, or ham." }
    ]
  },
  {
    category: "Bistro Brunches",
    items: [
      { name: "Tiramisu French Toast", price: "$17.00", desc: "Brioche French Toast loaded with Espresso Mascarpone Mousse, drizzled with Chocolate Sauce, dusted with cocoa powder, and finished with whipped cream." },
      { name: "Tatin Apple Crêpes", price: "$17.00", desc: "Sweet cream crêpes rolled with Vanilla Bourbon Mascarpone Crème and walnuts, finished with caramelized brown sugar apples, puff pastry crumble, and whipped cream." },
      { name: "Baked Eggs a la Française", price: "$17.75", desc: "Poached eggs nestled in a French baking crock with grilled hash browns, sautéed mushrooms and ham, topped with Gruyère Béchamel and Swiss cheese gratinée." },
      { name: "La Provence Benedict", price: "$18.25", desc: "Grilled ham steak and two poached eggs stacked on a freshly toasted Croissant and smothered in Hollandaise. (West Coast Salmon Benedict option: $20.50)" },
      { name: "Avocado Burrata Tartine", price: "$16.50", desc: "Mashed avocado dusted with house 'Everything Seasoning' on toasted French Country Bread, served open-faced with Burrata cheese, grape tomatoes, house-made Chili Crisp, and shaved radish." }
    ]
  },
  {
    category: "Soupe & Salade",
    items: [
      { name: "French Onion Soupe", price: "$10.50 (Bowl) / $8.75 (Cup)", desc: "Our signature soup! Deeply caramelized onions in our rich beef consommé. Topped with toasted Provence Bread loaded with Swiss and Parmesan cheese melted under the broiler." },
      { name: "Soupe du Jour", price: "$7.75 (Bowl) / $6.50 (Cup)", desc: "Please ask your server about today's freshly prepared soup." },
      { name: "Mesclun Greens Salade", price: "$6.50", desc: "Mesclun lettuce greens, grape tomatoes, Parmesan cheese, and your choice of dressing (House Balsamic, Light Balsamic, Champagne, or Seasonal)." },
      { name: "Salmon & Jeweled Quinoa Salade", price: "$19.25", desc: "Grilled salmon filet with pesto, jeweled quinoa salad with red grapes, apple, diced celery, Feta cheese, walnuts, and fresh basil, over organic mesclun greens." },
      { name: "Le Jardin Méditerranéen Salade", price: "$18.50", desc: "Herb-roasted chicken breast over organic greens tossed with our House Balsamic Dressing, cherry tomatoes, cucumbers, marinated mushrooms, Kalamata olives, and crumbled Feta cheese. Topped with crispy chickpeas." }
    ]
  },
  {
    category: "Lunch Favorites",
    items: [
      { name: "Parisien Jambon Ciabatta", price: "$17.25", desc: "Thinly sliced ham on our Ciabatta with Truffled Brie, pear slices, rosemary confit garlic, and vinaigrette dressed arugula." },
      { name: "Monte Cristo", price: "$17.50", desc: "Our famous double-decker sandwich! Turkey, ham, Swiss, Cheddar, pineapple, tomato, and mayonnaise stacked on our French Country Bread, dipped in egg batter, and grilled golden brown." },
      { name: "La Provence BLT", price: "$17.25", desc: "Thick-cut bacon, lettuce, sliced tomato, avocado, and a fried egg, on a freshly baked Croissant with our house-made Pesto Aioli." },
      { name: "Grilled Wild Albacore Tuna Melt", price: "$17.25", desc: "Wild Albacore tuna mixed with mayonnaise and finely chopped celery, onions, and carrots, then topped with tomato and melted Cheddar cheese on our grilled Sourdough Bread." },
      { name: "IPA Bacon Cheeseburger", price: "$18.25", desc: "American Angus beef patty stacked with bacon, Gruyère cheese, butter lettuce, tomato, red onion, house pickles, and IPA Mustard Aioli on our butter toasted Challah Roll." }
    ]
  },
  {
    category: "La Provence Desserts",
    items: [
      { name: "Versailles", price: "", desc: "French chocolate cake layered with vanilla, coffee, and dark chocolate mousse, and dark chocolate ganache. A mocha-lovers delight!" },
      { name: "Black Beauty", price: "", desc: "French chocolate cake with vanilla syrup, layered with dark chocolate ganache and mousse, covered with opera icing." },
      { name: "Tiramisu", price: "", desc: "Mascarpone mousse layered with chocolate cake and chocolate crunchy hazelnut ganache." },
      { name: "Éclair", price: "", desc: "Our tender pâte à choux filled with vanilla pastry cream and topped with dark chocolate ganache and chocolate decorations." },
      { name: "Pavlova", price: "", desc: "Crisp meringue filled with raspberry and passion fruit compote, topped with mascarpone chantilly cream." },
      { name: "Napoleon", price: "", desc: "Layers of puff pastry filled with vanilla cream." },
      { name: "Marionberry Cheesecake", price: "", desc: "A special French cheesecake with marionberries." },
      { name: "Lemon Tart", price: "", desc: "Classic zesty lemon tart." },
      { name: "Fresh Fruit Tart", price: "", desc: "Beautiful arrangement of fresh seasonal fruits on a pastry base." }
    ]
  }
];

function Menu() {
  return (
    <div className="container" style={{ maxWidth: '1000px' }}>
      <header style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h1 style={{ fontSize: '3.5rem', margin: '1rem 0' }}>La Provence Menu</h1>
        <p style={{ color: '#757575' }}>Fall/October Brunch Collection. Authentic recipes served fresh.</p>
      </header>

      {/* Foto Preview Menu */}
      <div className="menu-preview-images">
        <img src="https://images.unsplash.com/photo-1525351484163-7529414344d8?w=600&q=80" alt="Brunch Preview" />
        <img src="https://images.unsplash.com/photo-1551024601-bec78aea704b?w=600&q=80" alt="Dessert Preview" />
      </div>

      {/* Daftar Menu Text */}
      {menuData.map((section, index) => (
        <div key={index} className="menu-section">
          <h2 className="menu-category-title">{section.category}</h2>
          {section.items.map((item, idx) => (
             <div key={idx} className="menu-item">
               <div className="menu-item-header">
                 <span className="menu-item-name">{item.name}</span>
                 {item.price && <div className="menu-item-dots"></div>}
                 <span className="menu-item-price">{item.price}</span>
               </div>
               <p className="menu-item-desc">{item.desc}</p>
             </div>
          ))}
        </div>
      ))}

      <footer style={{ textAlign: 'center', marginTop: '4rem', padding: '2rem', borderTop: '1px solid #d7ccc8' }}>
        <p style={{ fontSize: '0.9rem', color: '#757575' }}>
          <em>*Eggs cooked to order. Consuming raw or undercooked meat, poultry, seafood, shellfish, or eggs may increase your risk of food borne illness.<br/>
          Split-Plate charge $4.00. 20% gratuity added to parties of 6+.</em>
        </p>
      </footer>
    </div>
  );
}

export default Menu;